/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu Jun 6 2019 3:16:54 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Stack, RadioButton, ButtonGroup, Button, FormLayout } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Field, reduxForm, SubmissionError } from 'redux-form';

import * as setupActions from 'actions/setup-actions';
import { RenderTextField } from 'src/components/views/common/forms/render-textfield';
import { RenderChoice } from 'src/components/views/common/forms/render-choice';
import { startSABLoading, stopSABLoading } from 'src/integrations/shopify-app-bridge/loading';
import { isRequired, isEmail, isEmpty, isExceedLength } from 'src/helpers/form-validation-helper';
import { issuesChoices as choices } from 'src/constants/feedback-options';
import { prettyText } from 'src/helpers';

const isRequiredValue = isRequired();
const isEmailValue = isEmail();
const isExceedLengthValue = isExceedLength(50);

type Props = {
  loading: boolean,
  success: boolean,
  handleSubmit: () => void,
  pristine: boolean,
  submitting: boolean,
  handleChangeState: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class Option2 extends Component<ComposedProps> {
  componentWillReceiveProps(nextProps) {
    if (nextProps.success === true) {
      const { handleChangeState } = this.props;

      //go to after submit page
      handleChangeState(6);
    }

    if (nextProps.loading === true && this.props.loading === false) {
      startSABLoading();
    }

    if (nextProps.loading === false && this.props.loading === true) {
      stopSABLoading();
    }
  }

  componentWillUnmout() {
    const { resetSetupFeedback } = this.props;
    resetSetupFeedback();
  }

  render() {
    const { loading, handleSubmit, pristine, submitting, i18n } = this.props;
    const formattedChoices = choices.map(function (choice) {
      return {
        ...choice,
        label: i18n.translate(choice.label)
      };
    });

    return (
      <div className="BC-Page__Installation__Option2 feedback-form">
        <form onSubmit={this.handleDefaultSubmit}>
          <Stack vertical>
            <RadioButton
              label={i18n.translate('AdminHTML.Installation.Feedback.option2_RadioButton_Label')}
              checked={true}
              id="2"
              name="options"
            />
            <div style={{ marginLeft: '1.75rem' }}>
              <FormLayout>
                <p style={{ marginTop: '-1rem' }}>
                  {i18n.translate('AdminHTML.Installation.Feedback.option2_Paragraph')}
                </p>

                <Field
                  name="issueList"
                  label={i18n.translate('AdminHTML.Installation.Feedback.option2_Field1_Label')}
                  choices={formattedChoices}
                  component={RenderChoice}
                  anotherProps={{ allowMultiple: 'true' }}
                />

                <Field
                  name="email"
                  label={i18n.translate('AdminHTML.Common.FieldLabel.yourEmail')}
                  component={RenderTextField}
                  placeholder={i18n.translate('AdminHTML.Common.Placeholder.email')}
                  validate={[isRequiredValue, isEmailValue, isExceedLengthValue]}
                />

                <Field
                  name="content"
                  label={i18n.translate('AdminHTML.Installation.Common.yourMessage')}
                  placeholder={i18n.translate(
                    'AdminHTML.Installation.Feedback.option2_Field3_Placeholder'
                  )}
                  component={RenderTextField}
                  anotherProps={{ multiline: 5 }}
                />
              </FormLayout>
            </div>
            <div style={{ marginLeft: 'auto' }}>
              <ButtonGroup>
                <Button onClick={this.back}>
                  {i18n.translate('AdminHTML.Common.Action.back')}
                </Button>
                <Button
                  primary
                  disabled={pristine || submitting}
                  loading={loading && !pristine}
                  onClick={handleSubmit(this.handleSave.bind(this))}>
                  {i18n.translate('AdminHTML.Common.Action.submit')}
                </Button>
              </ButtonGroup>
            </div>
          </Stack>

          <span className="clear" />
        </form>
      </div>
    );
  }

  // Handle default form submit
  handleDefaultSubmit(e) {
    e.preventDefault();
  }

  // Handle back action
  back = () => {
    const { handleChangeState } = this.props;

    handleChangeState(0);
  };

  // Validate value
  validateSubmit = data => {
    const { i18n } = this.props;
    if (data.issueList && data.issueList.length > 0) {
      if (data.issueList.includes('others') && isEmpty(data.content)) {
        throw new SubmissionError({
          content: i18n.translate('AdminHTML.Installation.Common.submissionError1')
        });
      }
    } else {
      throw new SubmissionError({
        issueList: i18n.translate('AdminHTML.Installation.Common.submissionError2')
      });
    }
    return true;
  };

  //Handle submit
  handleSave = data => {
    const { i18n } = this.props;
    if (this.validateSubmit(data)) {
      const { sendSetupFeedback } = this.props;
      let feedback = _.pick(data, ['email', 'content']);

      feedback.selections = _.map(data.issueList, item => {
        const itemFound = _.find(choices, { value: item });
        return { code: itemFound.code, codeDescription: i18n.translate(itemFound.label) };
      });
      feedback.content = prettyText(feedback.content);
      feedback.featureName = 'Installation';

      sendSetupFeedback(feedback);
    }
  };
}

const mapStateToProps = (state, props) => ({
  loading: state.setup.setupFeedbackLoading,
  success: state.setup.setupFeedbackSuccess,
  error: state.setup.error
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  sendSetupFeedback: (body: Object) =>
    dispatch(setupActions.sendSetupFeedback(body, ownProps.i18n)),
  resetSetupFeedback: () => dispatch(setupActions.resetSetupFeedback())
});

const Option2Form = reduxForm({
  form: 'Option2', // a unique identifier for this form
  enableReinitialize: true
})(Option2);

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(Option2Form));
